
export interface IWithdrawTokensRequest {
    amount: number,
    address: string,
    acceptTerms: boolean;
    type: WithdrawTokensType;
}

export interface IWithdrawResponseModel{
    userId: string;  
    tokensAmount: number; 
    dataEvent: Date; 
    addressWallet: string; 
    error: string; 
    refCode: string; 
    blockchainName: string; 
    blockchainSymbol: string; 
    contractAddress: string; 
}

export interface IWithdrawConfirmModel {
    userId: string,
    code: string
}

export enum WithdrawTokensType {
    Wallet = 0,
    AssoBay = 1
}